import DBSImg from '../../assets/images/home/dbs.png'
import MonatImg from '../../assets/images/home/monat.png'
import EuyansangImg from '../../assets/images/home/euyansang.png'
import PopularImg from '../../assets/images/home/popular.png'
import NtucImg from '../../assets/images/home/ntuc.png'
import ExeltecImg from '../../assets/images/home/exeltec.png'
import OnesysImg from '../../assets/images/home/onesys.png'
import Text from '../../Components/Text/Text'

const items = [
  {
    src: DBSImg,
    alt: 'DBS'
  },
  {
    src: MonatImg,
    alt: 'Charles Monat'
  },
  {
    src: EuyansangImg,
    alt: 'Eu Yan Sang'
  },
  {
    src: PopularImg,
    alt: 'Popular'
  },
  {
    src: NtucImg,
    alt: 'Popular'
  },
  {
    src: ExeltecImg,
    alt: 'Exeltec'
  },
  {
    src: OnesysImg,
    alt: 'Onesys Technologies'
  },
]

export function ImageSection({ items }) {
  return (
    <div className='flex items-center animate-swipe'>
      {items.map((item, index) => (
        <img
          key={index}
          src={item.src}
          alt={item.alt}
          className='max-w-[496px] h-[72px] object-contain cursor-pointer pr-[120px]'
        />
      ))}
    </div>
    
  )
}

export default function LeadersSection() {
  return (
    <div className='px-16 max-sm:px-4'>
      <Text type='h1' size='subD2' className='text-grey-700 mt-20 mb-28 max-sm:mb-16 max-sm:mt-12 text-center animate-fade-in-left'>Trusted by industry leaders</Text>
      <div className="w-full h-[72px] overflow-hidden mb-[167px] max-sm:mb-[96px]">
        <div className="flex">
          <ImageSection items={items} />
          <ImageSection items={items} />
        </div>
      </div>
    </div>
  )
}